import React, { FC } from "react";

import { Radio } from "antd";
import { useIntl } from "react-intl";

import { EntityType, EntityTypesSupportingEmail } from "@mapmycustomers/shared/types/entity";

import dealImage from "@app/assets/associations/deal.svg";
import RadioGroup from "@app/component/input/RadioGroup";
import { getEntityTypeDisplayName } from "@app/util/ui";

import styles from "./EmailButton.module.scss";
import messages from "./messages";
import RecipientType from "./RecipientType";
import getRecipientTypeDisplayName from "./util/getRecipientTypeDisplayName";

export interface SelectEmailRecipientTypeProps {
  displayRecipientTypes: RecipientType[];
  entityTypes: Array<EntityTypesSupportingEmail>;
  hasEntitiesFromDeal: boolean;
  onChangeRecipientType: (recipientType: RecipientType) => void;
}

const SelectEmailRecipientType: FC<SelectEmailRecipientTypeProps> = ({
  displayRecipientTypes,
  entityTypes,
  hasEntitiesFromDeal,
  onChangeRecipientType,
}) => {
  const intl = useIntl();

  return (
    <div>
      <p>
        {intl.formatMessage(
          entityTypes.length > 1
            ? messages.modalEntitySelectorText
            : messages.modalSingleEntitySelectorText,
          {
            entityType: getEntityTypeDisplayName(intl, entityTypes[0] ?? EntityType.COMPANY, {
              lowercase: true,
              plural: true,
            }),
          }
        )}
      </p>
      <RadioGroup defaultValue={displayRecipientTypes[0]} onChange={onChangeRecipientType}>
        {displayRecipientTypes.map((recipientType: RecipientType) => (
          <Radio.Button key={recipientType} value={recipientType}>
            {getRecipientTypeDisplayName(intl, recipientType)}
          </Radio.Button>
        ))}
      </RadioGroup>
      {hasEntitiesFromDeal && (
        <div className={styles.whatAboutDeals}>
          <div>
            <img alt="deal" className={styles.dealIcon} src={dealImage} />
          </div>
          <div>
            <div className={styles.whatAboutDealsTitle}>
              {intl.formatMessage(messages.whatAboutDeals)}
            </div>
            <div className={styles.whatAboutDealsText}>
              {intl.formatMessage(messages.whatAboutDealsText)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectEmailRecipientType;
